import { jsx as i } from "react/jsx-runtime";
import { Fab as d } from "./styles65.mjs";
import { AMPLITUDE_LABEL as c, AMPLITUDE_ACTION as n } from "./amplitude.mjs";
const b = ({
  children: t,
  testId: l,
  amplitudeLabel: m = c.button,
  amplitudeAction: o = n.click,
  size: a,
  ...r
}) => {
  const e = !a || !["small", "medium", "large"].includes(a);
  return /* @__PURE__ */ i(
    d,
    {
      $extraSmall: a === "extraSmall",
      "data-amplitude-label": m,
      "data-amplitude-action": o,
      "data-testid": l,
      size: e ? void 0 : a,
      ...r,
      children: t
    }
  );
};
export {
  b as Fab
};
//# sourceMappingURL=index98.mjs.map
